import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse,
  } from '@angular/common/http';
  import { Injectable } from '@angular/core';
  import { Observable, catchError, throwError } from 'rxjs';
  import { AuthService } from './auth.service';
  
  @Injectable({
    providedIn: 'root',
  })
  export class AppHttpInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}
  
    intercept(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
      const token = this.authService.getToken();
  
      const authReq = token
        ? request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          })
        : request;
  
      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('HTTP Error:', error);
  
          if (error.status === 401 && !request.url.toLowerCase().includes('/reports')) {
            // Unauthorized, logout user
            this.authService.logout();
          }
  
          return throwError(() => error);
        })
      );
    }
  }
  